import React, { useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Paper from "@mui/material/Paper";
import { Link } from "react-router-dom";
import { FaPencilAlt, FaTrashAlt } from "react-icons/fa";
import jsPDF from "jspdf";
import "jspdf-autotable";

const DataTable = ({ data, setSelectedId, handleShow }) => {
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("");

  // Sorting function
  const handleSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  // Sorting data based on selected column and order
  const sortedData = [...data].sort((a, b) => {
    if (!orderBy) return 0;
    if (a[orderBy] < b[orderBy]) return order === "asc" ? -1 : 1;
    if (a[orderBy] > b[orderBy]) return order === "asc" ? 1 : -1;
    return 0;
  });

  // Export to PDF functionality
  const exportPDF = () => {
    const doc = new jsPDF();
    doc.text(" Skype Data Table", 14, 10);
    doc.autoTable({
      startY: 20,
      head: [
        ["ID", "Title", "URL", "Owner", "Reg Date", "Status"],
      ],
      body: sortedData.map((item) => [
        item?.id,
        item?.title,
        item?.url,
        item?.owner,
        item?.dateentry,
        item?.active === 1 ? "active" : "inactive",
      ]),
    });
    doc.save("skype_data_table.pdf");
  };

  return (
    <>
      {/*<button onClick={exportPDF} className="mb-4 bg-primary text-white px-4 py-2 rounded-md">*/}
      {/*  Export to PDF*/}
      {/*</button>*/}
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="sortable and exportable table">
          <TableHead>
            <TableRow className="bg-primary">
              {[
                { label: "ID", field: "id" },
                { label: "Title", field: "title" },
                { label: "URL", field: "url" },
                { label: "Owner", field: "owner" },
                { label: "Reg Date", field: "dateentry" },
                { label: "Status", field: "active" },
              ].map(({ label, field }) => (
                <TableCell
                  key={field}
                  align="center"
                  className="!text-darkTextColor whitespace-nowrap"
                >
                  <TableSortLabel
                    active={orderBy === field}
                    direction={orderBy === field ? order : "asc"}
                    onClick={() => handleSort(field)}
                  >
                    {label}
                  </TableSortLabel>
                </TableCell>
              ))}
              <TableCell
                align="center"
                className="!text-darkTextColor whitespace-nowrap"
              >
                Actions
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedData.map((item) => (
              <TableRow
                key={item.id}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row" align="center">
                  {item?.id}
                </TableCell>
                <TableCell align="center">{item?.title}</TableCell>
                <TableCell align="center">
                  <a
                    className="inline-block w-full max-w-48 truncate"
                    href={item?.url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {item?.url}
                  </a>
                </TableCell>
                <TableCell align="center">{item?.owner}</TableCell>
                <TableCell align="center">{item?.dateentry}</TableCell>
                <TableCell align="center">
                  <span
                    className={`badge text-darkTextColor ${item?.active === 1 ? "bg-[#28a745]" : "bg-[#ff6877]"
                      }`}
                  >
                    {item?.active === 1 ? "active" : "inactive"}
                  </span>
                </TableCell>
                <TableCell align="center">
                  <div className="block h-full">
                    <div className="flex gap-x-10 items-center justify-center">
                      <Link
                        to={`/skypeGroups/Edit/${item?.id}`}
                        color="inherit"
                        underline="none"
                      >
                        <FaPencilAlt className="text-[#6c757d]" />
                      </Link>

                      <FaTrashAlt
                        onClick={() => {
                          setSelectedId(item?.id);
                          handleShow();
                        }}
                        className="text-[#d9534f] cursor-pointer"
                      />
                    </div>
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default DataTable;
